exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".service_page .btn-secondary[data-v-3b3b72b7]{color:#fff;border:0 solid}.service_page .btn-secondary[data-v-3b3b72b7]:before{background:#ec1b2e}.service_page .btn-secondary span[data-v-3b3b72b7]{position:relative;z-index:10}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib??vue-loader-options!./resources/js/components/service/SearchService.vue?vue&type=style&index=0&id=3b3b72b7&lang=scss&scoped=true&
// module id = 7KUD
// module chunks = 0